/**
 * @desc 获取一级部门审批人
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(options?: any) {
  return updateResponse(
    http(URL + `/lendMaster/getFirstApproval`, {
      method: "POST",

      ...options,
    }),
  );
}
